import { useNavigate } from 'react-router-dom';
import AppLayout from '../components/AppLayout';

export default function SelectRolePage() {
  const navigate = useNavigate();

  const handleSelectRole = (selectedRole: 'patient' | 'caregiver') => {
    navigate('/app');
  };

  return (
    <AppLayout>
      <div className="min-h-screen px-6 pt-12 pb-8 bg-white flex flex-col items-center justify-center">
        <div className="w-full max-w-sm">
          <div className="text-center mb-10">
            <div className="w-16 h-16 rounded-2xl bg-[#E8F5E9] flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-shared-line text-2xl text-[#2E7D6B]" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">역할 선택</h1>
            <p className="text-sm text-gray-500">
              두 가지 역할로 등록되어 있습니다.<br />오늘은 어떤 역할로 이용하시나요?
            </p>
          </div>

          <div className="space-y-4">
            <button
              onClick={() => handleSelectRole('patient')}
              className="w-full p-5 rounded-2xl border-2 border-gray-100 hover:border-[#2E7D6B] bg-gray-50 hover:bg-[#f0f9f6] text-left cursor-pointer transition-all"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0" style={{ backgroundColor: '#E8F5E9' }}>
                  <i className="ri-hospital-line text-xl" style={{ color: '#2E7D6B' }} />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-gray-900">환자 / 보호자</h3>
                  <p className="text-xs text-gray-500 mt-0.5">간병인 찾기, 간병 서비스 이용</p>
                </div>
                <i className="ri-arrow-right-s-line text-gray-400 text-xl" />
              </div>
            </button>

            <button
              onClick={() => handleSelectRole('caregiver')}
              className="w-full p-5 rounded-2xl border-2 border-gray-100 hover:border-[#1976D2] bg-gray-50 hover:bg-blue-50 text-left cursor-pointer transition-all"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0" style={{ backgroundColor: '#E3F2FD' }}>
                  <i className="ri-nurse-line text-xl" style={{ color: '#1976D2' }} />
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-gray-900">간병인</h3>
                  <p className="text-xs text-gray-500 mt-0.5">일자리 찾기, 간병 서비스 제공</p>
                </div>
                <i className="ri-arrow-right-s-line text-gray-400 text-xl" />
              </div>
            </button>
          </div>

          <p className="text-[10px] text-gray-400 text-center mt-8 leading-relaxed">
            선택한 역할에 따라 홈 화면이 달라집니다.<br />
            언제든 다른 역할로 전환할 수 있습니다.
          </p>
        </div>
      </div>
    </AppLayout>
  );
}